export default "__VITE_ASSET__c4c503c9__"